import { ClientType } from '../apollo'
import { types } from '../types'

import { updateOneChannelChatRoomMenu } from '@dinosband/bv-main-schema/dist/client-gql'

export async function updateChatRoomMenu (client: ClientType, id: number, data: types.ChannelChatRoomMenuUpdateInput): Promise<types.ChannelChatRoomMenu | undefined> {
  try {
    const result = await client.mutate({
      mutation: updateOneChannelChatRoomMenu,
      variables: {
        where: { id },
        data,
      },
    })
    return result.data.updateOneChannelChatRoomMenu
  } catch (e) {
  }
}

